<script setup>
import AdvancedSettingManager from '@/views/apps/settings/list/AdvancedSettingManager.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'settings',
  },
})
</script>

<template>
  <section>
    <AdvancedSettingManager />
  </section>
</template>
